import { Check } from 'lucide-react';
import { Checkbox as C } from 'radix-ui';
import { type ReactNode, useId } from 'react';

import { cx } from '@/lib/cx';

interface CheckboxProps {
  marcado: boolean;
  aoMudar: (marcado: boolean) => void;
  rotulo: ReactNode;
  descricao?: ReactNode;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  marcado,
  aoMudar,
  rotulo,
  descricao,
  disabled,
  className,
}: CheckboxProps) {
  const id = useId();
  return (
    <div className={cx('flex items-start gap-2.5', className)}>
      <C.Root
        id={id}
        checked={marcado}
        onCheckedChange={(valor) => {
          aoMudar(valor === true);
        }}
        disabled={disabled ?? false}
        aria-describedby={descricao ? `${id}-descricao` : undefined}
        className="mt-0.5 grid size-4 shrink-0 place-items-center rounded-mini border border-borda-forte bg-superficie transition-colors duration-[var(--duracao-rapida)] data-[state=checked]:border-marca data-[state=checked]:bg-marca disabled:opacity-50"
      >
        <C.Indicator className="animate-surgir text-marca-texto">
          <Check className="size-3" strokeWidth={3} aria-hidden />
        </C.Indicator>
      </C.Root>
      {/* Rótulo curto no nome; a explicação é a descrição (lida à parte pelo leitor de tela). */}
      <div className="grid gap-0.5 text-base leading-tight">
        <label htmlFor={id}>{rotulo}</label>
        {descricao && (
          <span id={`${id}-descricao`} className="text-xs text-texto-fraco">
            {descricao}
          </span>
        )}
      </div>
    </div>
  );
}
